(function () {
  window.dataLayer = window.dataLayer || [];

  function getLoggedInEmailFromDataLayer() {
    // Pull the most recent cl_email that was pushed
    for (var i = window.dataLayer.length - 1; i >= 0; i--) {
      var item = window.dataLayer[i];
      if (item && item.cl_email) return item.cl_email;
    }
    return null;
  }

  // Capture add-to-cart submits in Dawn (forms that POST to /cart/add)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action) return;

    // Dawn typically posts to /cart/add or ends with /cart/add
    if (!/\/cart\/add/.test(form.action)) return;

    var variantIdEl = form.querySelector('input[name="id"]');
    var qtyEl = form.querySelector('input[name="quantity"]');

    var variant_id = variantIdEl ? variantIdEl.value : null;
    var quantity = qtyEl ? Number(qtyEl.value || 1) : 1;

    window.dataLayer.push({
      event: 'add_to_cart',
      cl_variant_id: variant_id,
      cl_quantity: quantity,
      cl_email: getLoggedInEmailFromDataLayer() // may be null for guest users
    });
  }, true);
})();
